// ChipInput Component
// This file defines a component for displaying and managing a list of chips (tags) with add and remove functionality.

import { KeyboardEvent } from "react";
import {
  Chip,
  ChipInputClear,
  ChipInputContainer,
} from "./components.stitches";
import { CloseIcon } from "../Icons";

/**
 * Props for the ChipInput component
 * @param chips - The list of chip strings to display
 * @param onAddChip - Handler to add a new chip
 * @param onChipRemoval - Handler to remove a chip
 */
interface ChipInputProps {
  chips: string[];
  onAddChip: (chip: string) => void;
  onChipRemoval: (chip: string) => void;
}

/**
 * ChipInput Component
 * Renders a list of chips with remove buttons and an input for adding new chips.
 *
 * @param chips - The list of chip strings to display
 * @param onAddChip - Handler to add a new chip
 * @param onChipRemoval - Handler to remove a chip
 */
const ChipInput = ({ chips, onAddChip, onChipRemoval }: ChipInputProps) => {
  return (
    <div className="fe_c_input">
      <ChipInputContainer className="fe_c_input__input">
        {/* Render each chip with a remove button */}
        {!!chips.length &&
          chips.map((chip) => {
            return (
              <Chip key={chip}>
                {chip}
                <div
                  data-testid="chip-removal"
                  onClick={() => onChipRemoval(chip)}
                >
                  <CloseIcon width="12px" height="12px" />
                </div>
              </Chip>
            );
          })}

        {/* Input for adding new chips. Calls onAddChip on Enter key. */}
        <ChipInputClear
          placeholder="Type"
          type="text"
          onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
            if (e.key === "Enter") {
              onAddChip(e.currentTarget.value);
              e.currentTarget.value = "";
            }
          }}
        />
      </ChipInputContainer>
    </div>
  );
};

export default ChipInput;
